import { useState } from 'react'
import { bookDidYourMotherTellYou } from '@/assets/siteMedia'
import { GrainOverlay } from '@/components/ui/GrainOverlay'

export const BooksFeatured = () => {
  const [email, setEmail] = useState('')
  const [submitted, setSubmitted] = useState(false)

  return (
    <section className="bg-green-900 py-16 sm:py-20 lg:py-24 relative overflow-hidden text-base-50">
      <GrainOverlay opacity={0.025} />
      <div className="pointer-events-none absolute -left-40 -top-40 h-[560px] w-[560px] rounded-full bg-green-800/20 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-40 right-0 h-[420px] w-[420px] rounded-full bg-gold-400/10 blur-3xl" />

      <div className="max-w-6xl mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          {/* Book mockup */}
          <div className="flex justify-center lg:justify-end">
            <div className="relative">
              <div className="absolute -inset-12 bg-gold-400/6 blur-3xl rounded-full" />
              <div className="absolute -inset-6 bg-gold-400/4 blur-xl rounded-full" />
              <img
                src={bookDidYourMotherTellYou}
                alt="Book cover: Did Your Mother Tell You? Celebrating her first period, by Kandake Makonnen. Book One of The Cycle of Womanhood series."
                width={386}
                height={539}
                loading="lazy"
                className="relative w-52 rounded-md shadow-[0_40px_80px_rgba(0,0,0,0.7)] sm:w-64"
              />
              <div className="absolute -top-4 -right-5 bg-red-600 text-white text-[0.54rem] font-bold tracking-[0.16em] uppercase px-3.5 py-1.5 rounded-full shadow-lg border border-red-500/50">
                Coming Soon
              </div>
              <div className="absolute -bottom-5 left-6 right-6 h-8 bg-black/50 blur-xl rounded-full" />
            </div>
          </div>

          {/* Book copy + signup */}
          <div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-base-50 leading-tight tracking-tight mb-3">
              The Cycle of <span className="text-gold-200">Womanhood</span>
            </h2>
            <p className="text-gold-200 font-display text-lg mb-7 leading-snug">
              From Menarche to Menopause and Beyond
            </p>
            <p className="text-base-100 text-base leading-7 mb-4">
              A transformational three-volume exploration of women's health, blending traditional
              African and Caribbean healing wisdom, modern herbal science, and 20+ years of clinical
              specialist experience.
            </p>
            <p className="text-green-100 text-base leading-7 mb-8">
              Written for every woman who has ever been told her symptoms are normal when they are
              not. Written for the daughters, the mothers, and the grandmothers.
            </p>

            <p className="text-green-200 text-sm mb-4 font-medium tracking-wide">
              Be the first to know when it's published.
            </p>

            {submitted ? (
              <div className="flex items-center gap-2 text-base text-green-300 font-medium">
                <svg className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                    clipRule="evenodd"
                  />
                </svg>
                You're on the list. We'll be in touch.
              </div>
            ) : (
              <form
                onSubmit={(e) => {
                  e.preventDefault()
                  setSubmitted(true)
                  setEmail('')
                }}
                className="flex max-w-md flex-col gap-3 sm:flex-row"
              >
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email address"
                  aria-label="Your email address"
                  required
                  className="h-12 flex-1 rounded-full border border-white/20 bg-white/10 px-5 text-base text-base-50 placeholder:text-green-200 focus:border-gold-200 focus:outline-none focus:ring-2 focus:ring-gold-200/40 transition-colors"
                />
                <button
                  type="submit"
                  className="min-h-12 shrink-0 rounded-full bg-base-50 px-6 text-sm font-semibold text-green-950 transition-colors hover:bg-gold-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-200 focus-visible:ring-offset-4 focus-visible:ring-offset-green-950"
                >
                  Notify Me
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}
